import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=37cc43c4&"
import script from "./Trash.vue?vue&type=script&lang=js&"
export * from "./Trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports